
// https://developer.mozilla.org/en-US/docs/Web/API/Media_Streams_API/Constraints
export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: {
    ideal: 1280,
    min: 160,
    max: 1440
  },
  height: {
    max: 1080,
    ideal: 720,
    min: 320
  },
  frameRate: 24,
};

// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = 'TwilioVideoApp-selectedAudioInput';
export const SELECTED_AUDIO_OUTPUT_KEY = 'TwilioVideoApp-selectedAudioOutput';
export const SELECTED_VIDEO_INPUT_KEY = 'TwilioVideoApp-selectedVideoInput';
